/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

export * from './login/login.component';
export * from './auth-block/auth-block.component';
export * from './logout/logout.component';
export * from './register/register.component';
export * from './request-password/request-password.component';
export * from './reset-password/reset-password.component';
export * from './auth.component';
export * from './constants';
export * from './register-tenant/register-tenant.component';
export * from './otp-verify-dialog/otp-verify-dialog.component';
export * from './tenant-list/tenant-list.component';
export * from './contact-administartor/contact-administartor.component';
export * from './patient-signup/patient-signup.component';
export * from './patient-login/patient-login.component';
export * from './patient-videocall-login/patient-videocall-login.component';
export * from './reset-password-inside-app/reset-password-inside-app.component';
